import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon, RotateCcwIcon, InfinityIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { pricing, bonusShortList } from '../data/offer';
const reassurances = [{
  icon: ShieldCheckIcon,
  label: 'Pago seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: RotateCcwIcon,
  label: 'Garantía de 7 días'
}, {
  icon: InfinityIcon,
  label: 'Acceso de por vida'
}];
export function FinalCta() {
  return <section aria-labelledby="cierre-titulo" className="w-full bg-forest-900 text-cream-100" data-id="element-63" data-mp="1jasekxmct3kh">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-20 lg:py-28" data-id="element-64" data-mp="1ec7k7ets9e3y">
        <div className="grid gap-7 sm:gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20" data-id="element-65" data-mp="1t511n5sm84b9">
          <div data-id="element-66" data-mp="1o4d9ggsnhhfg">
            <h2 id="cierre-titulo" className="font-display text-2xl font-extrabold leading-[1.1] tracking-tight text-cream-50 sm:text-[2.75rem]" data-id="element-67" data-mp="1o5y569qpb6ew">
              Empezá hoy tu transformación de hábitos
            </h2>
            <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-moss-200 sm:mt-6 sm:text-lg" data-id="element-68" data-mp="n6nt13xlwezf">
              En 21 días podés dejar de depender de los “lunes” para empezar a cambiar. Con un plan
              claro, acciones concretas, herramientas para vencer la procrastinación, un tracker para
              medir tu progreso y un sistema para seguir después de los 21 días.
            </p>
            <p className="mt-3 font-display text-base font-bold text-cream-50 sm:mt-5 sm:text-xl" data-id="element-69" data-mp="163f6gwqgvzvk">
              Todo en un solo MegaPack.
            </p>
          </div>

          <div className="rounded-xl bg-cream-100 p-5 text-forest-900 sm:rounded-2xl sm:p-9" data-id="element-70" data-mp="1ftqdis5g6p6o">
            <div className="flex flex-wrap items-baseline gap-3" data-id="element-71" data-mp="1kt3aw6ty3eni">
              <span className="font-display text-lg font-semibold text-forest-800/50 line-through sm:text-xl" data-id="element-72" data-mp="1kvfpca0hv6vt">
                {pricing.regular}
              </span>
              <span className="font-display text-[2.5rem] font-extrabold leading-none tracking-tight sm:text-5xl" data-id="element-73" data-mp="1tuuglbohjlhd">
                {pricing.today}
              </span>
            </div>
            <p className="mt-2 font-display text-[13px] font-bold uppercase tracking-wider text-moss-600 sm:text-sm" data-id="element-74" data-mp="3lwdnqkwqel76">
              Ahorrás {pricing.savings}
            </p>

            <p className="mt-5 font-display text-[11px] font-bold uppercase tracking-[0.14em] sm:mt-7 sm:text-sm" data-id="element-75" data-mp="3uwiucsu3pfka">
              Incluye los 5 bonos gratis
            </p>
            <ul className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1.5 border-b border-cream-300 pb-4 sm:mt-3 sm:grid-cols-1 sm:gap-y-2 sm:pb-6" data-id="element-76" data-mp="dhvjyvdtprtd">
              {bonusShortList.map(bonus => <li key={bonus} className="flex gap-2 text-xs text-forest-800 sm:gap-3 sm:text-[15px]" data-id="element-77" data-mp="mfnyhxbq0vfp">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-moss-600 sm:mt-1 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-78" data-mp="icrbzvj28f6h" />
                  <span data-id="element-79" data-mp="2k81qoflpu29r">{bonus}</span>
                </li>)}
            </ul>

            <div className="mt-4 sm:mt-6" data-id="element-80" data-mp="2a2tshd3ngjxm">
              <CtaButton data-id="element-81" data-mp="2e3vqjqltypy0">Comprar y empezar ahora</CtaButton>
            </div>
            <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs text-forest-800/80 sm:mt-5 sm:gap-x-4 sm:gap-y-2 sm:text-[13px]" data-id="element-82" data-mp="2e5zsw442zgw6">
              {reassurances.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-1.5 sm:gap-2" data-id="element-83" data-mp="2598ql9yxr5t5">
                  <Icon className="h-3.5 w-3.5 shrink-0 text-moss-600 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-84" data-mp="1qczs4amvcwhs" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}